import { ChevronDown } from 'lucide-react';
import type { SelectHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

import { useFieldControl } from './field';
import { FIELD_SHELL } from './input';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * A native `<select>` with the chevron drawn by Lucide instead of the platform's own,
 * so the control looks identical on every OS while keeping native keyboard behaviour,
 * native mobile pickers and native form semantics (rules §48.2).
 */
export function Select({ className, id, children, ...rest }: SelectProps) {
  const field = useFieldControl();
  return (
    <span className="relative block">
      <select
        id={id ?? field?.controlId}
        aria-describedby={rest['aria-describedby'] ?? field?.describedBy}
        aria-invalid={rest['aria-invalid'] ?? (field?.invalid === true ? true : undefined)}
        required={rest.required ?? field?.required}
        className={cn(FIELD_SHELL, 'appearance-none pr-10', className)}
        {...rest}
      >
        {children}
      </select>
      <ChevronDown
        size={18}
        strokeWidth={2}
        aria-hidden="true"
        className="pointer-events-none absolute top-1/2 right-[14px] -translate-y-1/2 text-neutral-400-text"
      />
    </span>
  );
}
